import React from "react";
import useProductCategoryPath from "../../hooks/useProductCategory";
import {useRefreshHook} from "../../../common/hooks/useRefresh";
import useFiltersCatalog from "src/core/products/hooks/useFiltersCatalog";

const CategoryBar = ({render}) => {
  const [catalog] = useFiltersCatalog();

  const [, goToProductCategory] = useProductCategoryPath();
  const _categories = catalog ? catalog.categories : [];
  return render({
    categories: _categories,
    onChangeCategory: goToProductCategory,
  });
};

export default function CategoryBarWrapper(props) {
  const [refreshState] = useRefreshHook();
  return <CategoryBar key={refreshState} {...props} />;
}
